import { render, staticRenderFns } from "./BookChart.vue?vue&type=template&id=323dc975&scoped=true&"
import script from "./BookChart.vue?vue&type=script&lang=js&"
export * from "./BookChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323dc975",
  null
  
)

export default component.exports